const defOpts = {
  lang: 'ko-KR',
  pitch: 1,
  rate: 1,
}

export default function TTS(options) {
  if (!window.speechSynthesis) {
    alert('음성 재생을 지원하지 않는 브라우저입니다. 크롬, 파이어폭스 등의 최신 브라우저를 이용하세요.')
  }

  const _options = Object.assign(defOpts, options)
  const speaker = window.speechSynthesis

  return {
    play(text) {
      try {
        const speech = new window.SpeechSynthesisUtterance(text)
        speech.lang = _options.lang
        speech.pitch = _options.pitch
        speech.rate = _options.rate
        speaker.speak(speech)
      } catch (e) {
        /* ignore */
      }
    },
    stop() {
      try {
        speaker.cancel()
      } catch (e) {
        /* ignore */
      }
    },
  }
}
